var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 148,
    viewBox: "0 0 144 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M137.336 100.071C135.108 109.5 131.941 118.367 128.099 126.154C122.946 136.654 108.56 147.48 98.6906 146.376C91.7976 144.253 83.4861 139.964 73.9226 133.814C64.4003 128.25 54.5569 122.195 45.011 116.24C35.6723 111.432 26.8454 106.542 19.2177 101.522C12.1242 97.1796 6.58911 92.0853 3.26258 86.0303C0.822083 80.0799 0.854549 72.7758 3.699 64.1682C7.42338 55.4695 13.3487 46.3645 20.7049 37.5224C28.2743 28.8687 36.8697 20.849 45.8793 14.2222C54.8054 8.20263 64.1026 3.99506 73.3371 2.15768C82.5555 1.16375 91.8473 2.64305 100.802 6.77111C109.795 11.3339 117.599 17.6651 123.96 25.0147C130.262 32.0813 135.053 39.9187 138.1 48.1212C141.088 55.9138 142.417 64.2484 142.026 72.9459C141.872 81.4606 140.297 90.5879 137.336 100.071Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "6 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector21);
export default __webpack_public_path__ + "static/media/Vector-21.08f6cd950af4221dac1b2fb4dec85185.svg";
export { ForwardRef as ReactComponent };